import { NotificationsByIdName } from '../name';
import { SonarNotificationType } from '../../../@types';
import { updateNotificationsById } from '../@sync/update';
import { AMPLITUDE_EVENT, createLogSagaWithFn } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, PatchAction, SagaYieldType } from '@sonar-software/xuder';
import { patchNotificationsById, PatchNotificationsByIdRequest } from '../../../api';

type LogPatchNotificationsByIdRequest = PatchNotificationsByIdRequest & {
	type: SonarNotificationType;
};

const logPatchNotificationsByIdAsync = createLogSagaWithFn<
	PatchAction<typeof NotificationsByIdName, PatchNotificationsByIdRequest>
>((action) => {
	const data = action.data as LogPatchNotificationsByIdRequest;

	return {
		data: {
			type: data.type
		},
		id: AMPLITUDE_EVENT.NOTIFICATION_CLICKED
	};
});

export const notificationsByIdPatchSlice = createPatchAsyncSlice<
	typeof NotificationsByIdName,
	LogPatchNotificationsByIdRequest
>({
	additionalRequestSteps: [
		{
			actionHandler: logPatchNotificationsByIdAsync,
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		preRequestActionCreators: [ updateNotificationsById.syncActionCreator ]
	},
	name: 'NotificationsById',
	receive: false,
	request: true,
	requestHandler: patchNotificationsById
});
